import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';
import 'swiper/css';
import 'swiper/css/navigation';

interface ProductImageSliderProps {
  product: {
    id: number;
    images: string[];
  };
}

const ProductImageSlider: React.FC<ProductImageSliderProps> = ({ product }) => {
  if (!product?.images || product.images.length === 0) return null;

  return (
    <div className="product-slider-container">
      <Swiper
        modules={[Navigation]}
        spaceBetween={10}
        slidesPerView={1}
        navigation={{
          prevEl: `.swiper-button-prev-${product.id}`,
          nextEl: `.swiper-button-next-${product.id}`,
        }}
        className="product-swiper"
      >
        {product.images.map((image, index) => (
          <SwiperSlide key={index}>
            <img
              src={image}
              alt={`Product ${index + 1}`}
              className="product-slide-image"
            />
          </SwiperSlide>
        ))}
      </Swiper>

      <div className={`swiper-button-prev-${product.id} custom-swiper-button`}>
        <MdKeyboardArrowLeft size={28} />
      </div>
      <div className={`swiper-button-next-${product.id} custom-swiper-button`}>
        <MdKeyboardArrowRight size={28} />
      </div>

      <style jsx>{`
        .product-slider-container {
          position: relative;
          width: 100%;
          max-width: 500px;
          margin: auto;
          border-radius: 12px;
          overflow: hidden;
          background-color: #f9f9f9;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        }

        .product-slide-image {
          width: 100%;
          height: 400px;
          object-fit: contain;
          padding: 10px;
          background-color: #fff;
          border-radius: 10px;
          transition: transform 0.3s ease;
        }

        .product-slide-image:hover {
          transform: scale(1.03);
        }

        .custom-swiper-button {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          z-index: 10;
          background: rgba(255, 255, 255, 0.9);
          border-radius: 50%;
          padding: 8px;
          cursor: pointer;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
          transition: all 0.3s ease;
          color: #333;
        }

        .custom-swiper-button:hover {
          background: rgba(0, 0, 0, 0.7);
          color: #fff;
        }

        .swiper-button-prev-${product.id} {
          left: 10px;
        }

        .swiper-button-next-${product.id} {
          right: 10px;
        }
      `}</style>
    </div>
  );
};

export default ProductImageSlider;
